const TIER_FILTER = {
  ONE: {
    label: 'One',
    value: 1,
  },
  TWO: {
    label: 'Two',
    value: 2,
  },
  THREE: {
    label: 'Three',
    value: 3,
  },
  FOUR: {
    label: 'Four',
    value: 4,
  },
  FIVE: {
    label: 'Five',
    value: 5,
  },
}

export default TIER_FILTER
